module.exports = __webpack_public_path__ + "travel.ef894c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/travel.png
// module id = 1747
// module chunks = 0